import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ButtonSizes } from '@app/app/shared/styleguide/components/buttons/default/button.component';
import { IconComponent } from '@app/app/shared/styleguide/components/icon/icon.component';
import { PtlPillComponent } from '@app/app/shared/styleguide/components/pill/ptl-pill.component';
import { LucideIconInput } from '@lucide/angular';

@Component({
  selector: 'ptl-sidebar-item-base',
  templateUrl: './sidebar-item-base.component.html',
  styleUrls: ['./sidebar-item-base.component.scss'],
  standalone: true,
  imports: [IconComponent, PtlPillComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarItemBaseComponent {
  text = input<string>();
  count = input<number>();
  /** Count shown as a pill next to the label (e.g. unread post count), as opposed to `count` which overlays the icon. */
  pillCount = input<number>();
  icon = input<LucideIconInput>();
  size = input<ButtonSizes>('l');
  hasUpdates = input(false);
  updatesLabel = input<string>();
  isActive = input(false);
}
